import Vue from "vue";
import App from "./App.vue";
import router from "./router";

// Import Amplify Modules, Plugins, and aws exports file
import Amplify, * as AmplifyModules from "aws-amplify";
import { AmplifyPlugin } from "aws-amplify-vue";
import awsconfig from "./aws-exports";
import { BootstrapVue } from "bootstrap-vue";
//import axios from "axios";

// Import Bootstrap Vue

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-vue/dist/bootstrap-vue.min.css";
import vuetify from "./plugins/vuetify";
import {} from "bootstrap-vue";
// Configure Amplify in project
Amplify.configure(awsconfig);

// Configure vue to use plugins and modules
Vue.use(AmplifyPlugin, AmplifyModules);

// Configure Boostrap Vue

// This imports the dropdown and table plugins
import {
  ButtonPlugin,
  PaginationPlugin,
  FormSelectPlugin,
  FormGroupPlugin,
  FormInputPlugin,
  LayoutPlugin,
  DropdownPlugin,
  TablePlugin,
  BIcon,
  BIconBoxArrowUpRight,
  BSidebar,
  VBToggle,
} from "bootstrap-vue";

Vue.use(DropdownPlugin);
Vue.use(TablePlugin);
Vue.use(LayoutPlugin);
Vue.use(PaginationPlugin);
Vue.use(ButtonPlugin);
Vue.use(FormSelectPlugin);
Vue.use(FormGroupPlugin);
Vue.use(FormInputPlugin);
Vue.component("b-sidebar", BSidebar);
Vue.directive("b-toggle", VBToggle);
Vue.component("BIcon", BIcon);
Vue.component("BIconBoxArrowUpRight", BIconBoxArrowUpRight);

Vue.config.productionTip = false;

Vue.use(BootstrapVue);
Vue.config.silent = true;

// Mount axios to the Vue prototype so it's globally available
//axios.defaults.headers.common["Content-Type"] = "application/json";
//Vue.prototype.$axios = axios;

new Vue({
  router,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
